import Avatar from "components-old/ui/Avatar"
import React from "react"
import { ExternalToast, toast as toastSonner } from "sonner"
import { getAsset } from "./helper"
import _ from "lodash"
import { Link } from "react-router-dom"
import { LinkButton } from "pages/settings/channels/email/AddChannelEmail"
import { isAldeia } from "hooks/useAldeia"
import { cn } from "./utils"

const toastBasicClassName =
  // "!border-transparent !rounded-2xl !text-white !bg-[#161618] dark:!bg-ground dark:outline dark:outline-2 dark:outline-white/10 !gap-2 !-ml-1"
  // "!border-transparent !rounded-2xl !text-white !bg-[#161618] dark:!bg-[#141420] dark:text-indigo-100 dark:!outline dark:!outline-2 dark:!outline-solid dark:!outline-indigo-500/30 !gap-2 !-ml-1"
  // "!border-transparent !rounded-2xl !text-white !bg-[#161618] dark:text-indigo-100 dark:!outline dark:!outline-2 dark:!outline-white/20 !gap-2 !-ml-1"
  "!border-transparent !rounded-2xl !text-white !bg-[#161618] dark:text-indigo-100 !gap-2 !-ml-1"

export const toast = {
  success: (content: string | React.ReactNode, duration: number = 4, props?: any) => {
    toastSonner.success(content, {
      duration: duration * 1000,
      ...props,
      classNames: {
        toast: isAldeia
          ? toastBasicClassName
          : "!border-green-600 !border-solid !border !text-green-600 !bg-base-100 !rounded-xl !font-semibold dark:!bg-green-700 dark:!border-green-700 dark:!text-green-50",
      },
      id: props?.id || props?.key,
    })

    // storeJotai.set(toastAtom, [
    //   "success",
    //   {
    //     content,
    //     duration,
    //     icon: <i className="fas fa-check-circle" />,
    //     ...props,
    //   },
    // ])
  },
  error: (_content: string | React.ReactNode, duration: number = 5, props?: any) => {
    const { prefix, ...rest } = props || {}
    let content = _content
    if (typeof _content === "string") {
      content = _content?.replace?.("HttpException-", "")
    }

    let final = prefix ? (
      <span>
        <span className={isAldeia ? "!text-red-500 text-2sm !font-bold":"opacity-65 text-xs"}>
          {prefix}
          <br />
        </span>
        {content}
      </span>
    ) : (
      content
    )

    if (isAldeia) {
      final = (
        <span>
          <span className="!text-red-500 text-2sm !font-bold flex items-center gap-1">
            Error
            {prefix && <IconCiCaretRightSm />}
            {prefix && <span className="!text-red-300 text-2sm !font-medium flex">{prefix}</span>}
            <br />
          </span>
          {content}
        </span>
      )
    }

    return toastSonner.error(final, {
      duration: duration * 1000,
      // icon: <i className="fas fa-do-not-enter text-md" />,
      // position: "top-center",
      classNames: {
        toast: isAldeia
          ? cn(toastBasicClassName)
          : "!border-red-600 !border-solid !border !text-red-600 !bg-base-100 !rounded-xl !font-semibold dark:!bg-red-700 dark:!border-red-700 dark:!text-red-50",
      },
      ...rest,
      id: props?.id || props?.key,
    })
  },
  info: (content: string | React.ReactNode, duration: number = 4, props?: any) => {
    return toastSonner.error(content, {
      duration: duration * 1000,
      // icon: <i className="fas fa-info-circle text-md" />,
      icon: isAldeia ? (
        <IconMageInformationCircleFill className="!text-neutral-400 outline outline-4 outline-blue-500/10 rounded-full size-5" />
      ) : (
        <i className="text-lg fas fa-info-circle fc" />
      ),
      classNames: {
        toast: isAldeia
          ? toastBasicClassName
          : "!border-slate-500 !border-solid !border !text-slate-500 !bg-base-100 !rounded-xl !font-semibold dark:!bg-[var(--dropdown-background)] dark:!text-slate-50 dark:!border-[var(--dropdown-background)]",
      },
      ...props,
      id: props?.id || props?.key,
    })
  },
  warning: (content: string | React.ReactNode, duration: number = 5, props?: any) => {
    return toastSonner.warning(content, {
      duration: duration * 1000,
      // icon: <i className="fas fa-exclamation-circle text-md" />,
      classNames: {
        toast: isAldeia
          ? toastBasicClassName
          : "!border-amber-600 !border-solid !border !text-amber-600 !bg-base-100 !rounded-xl !font-semibold dark:!bg-yellow-600 dark:!border-yellow-600 dark:!text-yellow-50",
      },
      ...props,
      id: props?.id || props?.key,
    })
  },
  loading: (content: string | React.ReactNode, duration: number = 5, props?: any) => {
    const toastId = toastSonner.loading(content, {
      duration: duration * 1000,
      classNames: {
        toast: isAldeia
          ? toastBasicClassName
          : "!border-neutral-400 !border-solid !border !text-neutral-500 !bg-base-100 !rounded-xl !font-semibold dark:!bg-[var(--dropdown-background)] dark:!text-slate-50 dark:!border-[var(--dropdown-background)]",
      },
      ...props,
      id: props?.id || props?.key,
    })

    return () => {
      toastSonner.dismiss(toastId)
    }
  },
  dismiss: (id: string) => {
    toastSonner.dismiss(id)
  },
  message: (message: string | React.ReactNode, data?: ExternalToast) => {
    toastSonner.message(message, {
      ...data,
      position: "top-right",
      duration: Infinity,
      classNames: {
        toast: isAldeia
          ? "!bg-base-100 !rounded-xl"
          : "!bg-base-100 !rounded-xl dark:!bg-[var(--dropdown-background)] dark:!text-slate-50 dark:!border-[var(--dropdown-background)]",
      },
    })
  },
  mention: (
    props: {
      title: string
      icon?: any
      content: string | React.ReactNode
      avatar?: string
      channel?: string
      to?: string
      onClick?: () => void
      id?: string
      toastClassName?: string
      duration?: number
    },
    data?: ExternalToast,
  ) => {
    const { title, content, avatar, channel, icon, to, duration, onClick } = props
    // toastSonner.custom(
    //   (id) => (
    //     <div className="flex gap-2 items-center w-full">
    //       <Avatar imgSrc={getAsset(avatar)} name={title} />
    //       <div>
    //         <span className="font-semibold">{title}</span>
    //         <div className="text-sm text-content-200">{description}</div>
    //       </div>
    //     </div>
    //   ),
    //   {
    //     position: "top-right",
    //     classNames: {
    //       toast: "toast !bg-base-100 !rounded-xl !w-[356px] shadow-[0_4px_12px_rgba(0,0,0,.1)]",
    //       actionButton: "!bg-[var(--secondary-button-background)]",
    //     },
    //     duration: Infinity,
    //     // action: {
    //     //   label: "Ver",
    //     //   onClick: () => console.log("Action!"),
    //     // },
    //     ...data,
    //   },
    // )

    const LinkOrButton = to ? Link : LinkButton

    const id = toastSonner.message(
      <LinkOrButton
        to={to!}
        className={cn("flex items-start gap-2.5 w-full p-4 cursor-pointer", isAldeia ? toastBasicClassName : "")}
        onClick={() => {
          toastSonner.dismiss(id)
          onClick?.()
        }}
      >
        {icon || <Avatar imgSrc={getAsset(avatar)} name={title} className="mt-1" />}
        <div>
          <div className="flex gap-1 items-center">
            <div className="font-semibold text-2sm truncate max-w-[160px]">{title}</div>
            {channel && <div className="text-xs text-yellow-400 font-bold truncate max-w-[100px]">{channel}</div>}
          </div>
          <div className={cn("text-xs font-normal aldeia:text-2sm text-content-100", isAldeia ? "!text-white/70":"")}>
            {typeof content === "string" ? _.truncate(content, { length: 95 }) : content}
          </div>
        </div>
      </LinkOrButton>,
      {
        position: isAldeia ? "bottom-right" : "top-right",
        // duration: Infinity,
        closeButton: true,

        // action: {
        //   label: "Ver",
        //   onClick: () => console.log("Action!"),
        // },
        classNames: {
          toast: isAldeia
            ? cn("!p-0 [&>div]:!w-full", props.toastClassName)
            : cn(
                "!bg-base-100 !rounded-xl !p-0 [&>div]:!w-full dark:!bg-[var(--dropdown-background)] dark:!text-slate-50 dark:!border-[var(--dropdown-background)]",
                props.toastClassName,
              ),
          closeButton: isAldeia ? "!bg-[#161618] !text-white !border-white/20" : " !bg-[var(--dropdown-background)] !text-content-100 dark:!text-white !border-divider dark:!border-white/20",
          // actionButton: "!bg-[var(--secondary-button-background)]",
        },
        ...data,
        duration: data?.duration || duration ? (data?.duration || duration || 0) * 1000 : undefined,
      },
    )
  },
}

export default toast
